export default "__VITE_ASSET__DzNq4uDg__"